// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__ChOXl","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__U26jX","gfeWrapper":"CalendarEvent_gfeWrapper__3JJVy"};